import { render, staticRenderFns } from "./digLthree.vue?vue&type=template&id=71717f1c&scoped=true"
import script from "./digLthree.vue?vue&type=script&lang=js"
export * from "./digLthree.vue?vue&type=script&lang=js"
import style0 from "./digLthree.vue?vue&type=style&index=0&id=71717f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71717f1c",
  null
  
)

export default component.exports